import { render, staticRenderFns } from "./first-friend.vue?vue&type=template&id=25995b01&scoped=true"
import script from "./first-friend.vue?vue&type=script&lang=js"
export * from "./first-friend.vue?vue&type=script&lang=js"
import style0 from "./first-friend.vue?vue&type=style&index=0&id=25995b01&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "25995b01",
  null
  
)

export default component.exports